export enum HorseDiscipline{
  ALLROUNDER = 'All Rounder',
  DRESSAGE = 'Dressage',
  JUMPING = 'Jumping',
  EVENTING = 'Eventing',
  HACKING = 'Hacking',
  ENDURANCE = 'Endurance',
  SHOWING = 'Showing'
}
